export const COLOR_BLUE = "rgb(55, 115, 225)";
export const MAX_WIDTH = 1440;
export const POPUP_WIDTH = 83; //percentage
